export const demoData = {
    lines: [
        {
            name: 'WRG',
            points: [
                { x: 0, y: 100 },
                { x: 20, y: 100 },
                { x: 50, y: 0 },
                { x: 100, y: 0 },
            ],
            key: 'heatrecovery',
        },
        {
            name: 'Kühlen',
            points: [
                { x: 0, y: 0 },
                { x: 20, y: 0 },
                { x: 50, y: 100 },
                { x: 100, y: 100 },
            ],
            key: 'cooling',
        },
        {
            name: 'Heizen',
            points: [
                { x: 0, y: 0 },
                { x: 10, y: 0 },
                { x: 40, y: 100 },
                { x: 100, y: 100 },
            ],
            key: 'heating',
        },
    ]
} 